/**
 * SHARED
 * Cross-cutting code usable by any module. Must not import from any module.
 */

// Brand Command logo as a tight inline lockup (cube mark + wordmark), so it
// centers as a single unit with no dead whitespace. Sizes are props so the
// same component works large on auth screens and small in the top nav.
export default function BrandLogo({ cube = 60, word = 24, tag = 9.5, gap = 12, tagline = true }) {
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap }}>
      <svg width={cube} height={cube} viewBox="0 0 100 100" style={{ flexShrink: 0 }} aria-hidden="true">
        <defs>
          <linearGradient id="bcLogoCube" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#9DB6D4" />
            <stop offset="1" stopColor="#3E5C86" />
          </linearGradient>
        </defs>
        <g stroke="#2E4A72" strokeWidth="1.5" fill="url(#bcLogoCube)">
          <rect x="20" y="14" width="13" height="13" rx="1" />
          <rect x="40" y="30" width="20" height="20" rx="1" />
          <rect x="20" y="44" width="18" height="18" rx="1" />
          <rect x="60" y="44" width="18" height="18" rx="1" />
          <rect x="30" y="62" width="20" height="20" rx="1" />
          <rect x="52" y="62" width="20" height="20" rx="1" />
        </g>
        <path
          d="M44 40 L82 18 M82 18 L70 16 M82 18 L80 30"
          stroke="#3E5C86"
          strokeWidth="4"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
        <span style={{ color: "var(--heading, #1B2A4A)", fontWeight: 800, fontSize: word, letterSpacing: ".02em" }}>
          BRAND COMMAND
        </span>
        {tagline && (
          <span style={{ color: "var(--muted, #7A89A8)", fontWeight: 600, fontSize: tag, letterSpacing: ".15em", marginTop: word * 0.22 }}>
            OPERATIONS SOFTWARE FOR BRANDS
          </span>
        )}
      </div>
    </div>
  );
}
